import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { IOnboardingReportSummary } from '../../fi-onboarding-report';
import { IReportChartData } from '@fi-shared/fi-report-pie-chart/fi-report-pie-chart';
import { AppTextService } from '@fi-shared/app-text';
import { IChartHistoryData } from '@fi-shared/fi-chart-history/fi-chart-history.d';

@Component({
    selector: 'fi-onboarding-report-summary-chart',
    templateUrl: './fi-onboarding-report-summary-chart.component.html',
    styleUrls: ['./fi-onboarding-report-summary-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-report-summary-chart' },
    standalone: false,
})
export class FiOnboardingReportSummaryChartComponent {
    public reportSummary = input.required<IOnboardingReportSummary>();
    public isOnlyCompleted = input<boolean>(false);

    private appTextService = inject(AppTextService);

    protected reportChartData = computed<IReportChartData[]>(() => {
        const completedChartData = {
            gradientColorLight: '#99FFA3',
            gradientColorBright: '#13CA25',
            value: this.reportSummary()?.CompletedCount || 0,
        };

        if (this.isOnlyCompleted()) {
            return [completedChartData];
        }

        return [
            completedChartData,
            {
                gradientColorLight: '#2196F3',
                gradientColorBright: '#0672C9',
                value: this.reportSummary()?.InProgressCount || 0,
            },
            {
                gradientColorLight: '#E5EFF5',
                gradientColorBright: '#C7C8C9',
                value: this.reportSummary()?.NotStartedCount || 0,
            },
        ];
    });

    protected historyItems = computed<IChartHistoryData[]>(() => {
        const completedHistoryItem = {
            indicatorClass: 'green',
            label: this.appTextService.get('common.completed_plural'),
            value: this.reportSummary()?.CompletedCount || 0,
        };

        if (this.isOnlyCompleted()) {
            return [completedHistoryItem];
        }
        return [
            completedHistoryItem,
            {
                indicatorClass: 'blue',
                label: this.appTextService.get('task.in_progress'),
                value: this.reportSummary()?.InProgressCount || 0,
            },
            {
                indicatorClass: 'grey',
                label: this.appTextService.get('onboarding.not_started_yet'),
                value: this.reportSummary()?.NotStartedCount || 0,
            },
        ];
    });
}
